export default __webpack_public_path__ + "2a58957e5f135624ddc3a11db951afbd.png";